<app-card-v2 [hideHeader]="true">
    <div class="row">
        <app-form-field label="Sport" required="true" sizeLg="4" sizeXl="2">
            <app-lov-value-select-filter [newItemModalOptions]="newSportModalProps"
                                         [parentFormGroup]="formGroup" lovListName="SPORT"
                                         parentFormControlName="sportLovValue"
                                         style="width: 100%"></app-lov-value-select-filter>
        </app-form-field>
        <app-form-field label="Type" sizeLg="4" sizeXl="2">
            <app-lov-value-select-filter [parentFormGroup]="formGroup" lovListName="MEDICAL_RECORD_SPORT_TYPE"
                                         parentFormControlName="typeLovValue"
                                         style="width: 100%"></app-lov-value-select-filter>
        </app-form-field>
        <app-form-field label="Fréquence" sizeLg="4" sizeXl="2">
            <app-lov-value-select-filter [parentFormGroup]="formGroup" lovListName="FREQUENCY"
                                         parentFormControlName="frequencyLovValue"
                                         style="width: 100%"></app-lov-value-select-filter>
        </app-form-field>
        <app-form-field label="Type de revêtement" sizeLg="4" sizeXl="2">
            <app-lov-value-select-filter [parentFormGroup]="formGroup" lovListName="MEDICAL_RECORD_SPORT_FLOORING"
                                         parentFormControlName="flooringLovValue"
                                         style="width: 100%"></app-lov-value-select-filter>
        </app-form-field>
        <app-form-field label="Année de début" sizeLg="4" sizeXl="2">
            <app-medical-record-sport-year-input
                    [parentFormGroup]="formGroup"
                    parentFormControlName="startYear">
            </app-medical-record-sport-year-input>
        </app-form-field>
        <app-form-field label="Année de fin" sizeLg="4" sizeXl="2">
            <app-medical-record-sport-year-input
                    [parentFormGroup]="formGroup"
                    parentFormControlName="endYear">
            </app-medical-record-sport-year-input>
        </app-form-field>
        <app-form-field label="Commentaire" size="12">
            <app-rich-text-editor [parentFormGroup]="formGroup" [audioTranscriptionConfig]="audioTranscriptionConfig"
                                  parentFormControlName="comment"></app-rich-text-editor>
        </app-form-field>
    </div>
</app-card-v2>
